import { render, staticRenderFns } from "./LifeskillVideos.vue?vue&type=template&id=419d028a&scoped=true&"
import script from "./LifeskillVideos.vue?vue&type=script&lang=js&"
export * from "./LifeskillVideos.vue?vue&type=script&lang=js&"
import style0 from "./LifeskillVideos.vue?vue&type=style&index=0&id=419d028a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419d028a",
  null
  
)

/* custom blocks */
import block0 from "./LifeskillVideos.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports